import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Certification } from '../../../models/certification.model';
import { CertificationService } from './../../../services/certification/certification.service';

@Component({
  selector: 'app-certification-form',
  templateUrl: 'certificationForm.html',
  styles: ['label.required:after {top: 0} .ui-grid-row {margin-bottom: 7px}']
})

export class CertificationFormComponent implements OnChanges, OnInit {
  @Output() certificationAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() certificationUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Input() dialogBoxCertification: Certification;
  addEditForm: FormGroup;
  invalidSubmit: boolean;
  validation: any;

  constructor(
    private fb: FormBuilder,
    private srvCertification: CertificationService
  ) {}

  ngOnInit(): void {
    this.loadValidation();
  }

  loadValidation() {
    this.srvCertification.getFields().subscribe(res => {
      this.validation = res;
    });
  }

  ngOnChanges(...args: any[]) {
    this.addEditForm = this.fb.group({
        'code': new FormControl(this.dialogBoxCertification.code),
        'description': new FormControl(this.dialogBoxCertification.description)
    });
  }

  saveOrUpdate(): void {
    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }

    let newData = Object.assign({}, this.dialogBoxCertification, this.addEditForm.value);
    if (newData.id == null) {
      this.certificationAdded.emit(newData);
    } else {
      this.certificationUpdated.emit(newData);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/certification/certificationForm.component.ts